export enum Colors {
    Blue = "#82D0F3",
    Pink = "#E72B78",
}